// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/header');
require('@js/scroll-down');
require('@js/animations');
require('@js/sliders');
require('@js/accordions');
require('@js/modals');
require('@js/team-modal');
require('@js/tabs');
require('@js/contact-form');
require('@js/quick-links');
require('@js/map');
require('@js/calc-functions.js');
